import * as yup from "yup";

export const validation = yup.object().shape({
  firstname: yup.string().required("Este campo es obligatorio"),
  lastname: yup.string().required("Este campo es obligatorio"),
  dni: yup
    .number()
    .typeError("Ingrese un N° de DNI")
    .min(100000, "Debe ser un DNI válido")
    .required("Este campo es obligatorio"),
  cuit: yup
    .number()
    .typeError("Ingrese un n° de CUIT sin guiones")
    .min(100000000, "Debe ser un CUIT válido")
    .required("Este campo es obligatorio"),
  address: yup.string().required("Este campo es obligatorio"),
  email: yup
    .string()
    .email("debe ser un domicilio electrónico válido")
    .required("Este campo es obligatorio"),
  domain: yup.string().required("Este campo es obligatorio"),
  category: yup.string().required("Este campo es obligatorio"),
});

